import { Link } from 'react-router-dom';
import { useI18n } from '@/lib/i18n';

function NotFoundPage() {
  const { t } = useI18n();
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-surface-hover">
      <h1 className="text-6xl font-bold text-suzuki-blue">404</h1>
      <p className="mt-4 text-lg text-ink-muted">{t('tp.notFound.title')}</p>
      <Link
        to="/dashboard"
        className="mt-6 rounded-md bg-suzuki-blue px-4 py-2 text-sm font-medium text-white hover:bg-suzuki-blue/90 focus:outline-none focus:ring-2 focus:ring-suzuki-blue focus:ring-offset-2"
      >
        {t('tp.notFound.goToDashboard')}
      </Link>
    </div>
  );
}

export default NotFoundPage;
